export interface VideoItem {
  id: string;
  title: string;
  type: 'movie' | 'tv' | 'variety';
  subType: string;
  region: string;
  year: number;
  genres: string[];
  cast: string[];
  director: string;
  rating: number;
  views: number;
  likes: number;
  updateDate: string;
  status: string;
  cover: string;
  description: string;
  episodes: number;
}

export const typeLabels: Record<string, string> = {
  movie: '电影',
  tv: '电视剧',
  variety: '综艺',
};

export const typeIntroductions: Record<string, string> = {
  movie: '精选海内外电影佳作，涵盖动作、科幻、爱情、悬疑等多元类型，畅享大银幕体验。',
  tv: '汇集热播电视剧与口碑剧集，古装、都市、悬疑、武侠应有尽有，一追到底。',
  variety: '人气综艺与真人秀节目，音乐、美食、脱口秀、户外挑战，轻松下饭必备。',
};

export const regions = ['全部', '中国大陆', '中国香港', '美国', '英国', '韩国'];

export const years = ['全部', '2024', '2023', '2022', '2021', '更早'];

export const sortOptions = [
  { key: 'latest', label: '按更新日期' },
  { key: 'popular', label: '按热门度' },
  { key: 'rating', label: '按评分' },
];

export const subTypesByType: Record<string, string[]> = {
  movie: ['全部', '动作', '科幻', '爱情', '悬疑', '古装'],
  tv: ['全部', '古装', '都市', '悬疑', '武侠', '科幻', '治愈'],
  variety: ['全部', '真人秀', '音乐', '美食', '脱口秀', '户外'],
};

export const videoList: VideoItem[] = [
  {
    id: 'v001',
    title: '星海远征',
    type: 'movie',
    subType: '科幻',
    region: '中国大陆',
    year: 2024,
    genres: ['科幻', '冒险', '剧情'],
    cast: ['林知远', '苏未晞', '陈默白'],
    director: '高远航',
    rating: 8.7,
    views: 12860000,
    likes: 342000,
    updateDate: '2024-09-28',
    status: '已完结',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20before%20a%20glowing%20blue%20planet%2C%20deep%20space%20station%20silhouette%2C%20dark%20moody%20background%20with%20soft%20rim%20light%2C%20dramatic%20professional%20poster%20art%2C%20high%20detail&width=400&height=600&seq=mock-cover-001&orientation=portrait',
    description:
      '近未来，一支远征队踏上探索类地行星的旅程。面对未知的宇宙震荡与人性抉择，他们必须决定：是带回希望，还是成为星海中的又一缕回声。',
    episodes: 0,
  },
  {
    id: 'v002',
    title: '暗夜追踪',
    type: 'movie',
    subType: '悬疑',
    region: '中国香港',
    year: 2023,
    genres: ['悬疑', '犯罪', '剧情'],
    cast: ['郑锦生', '何静仪', '吴卓航'],
    director: '关家铭',
    rating: 8.2,
    views: 9650000,
    likes: 218000,
    updateDate: '2024-07-15',
    status: '已完结',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20movie%20poster%20of%20a%20detective%20under%20neon%20rain%20filled%20night%20alley%20in%20hong%20kong%2C%20dark%20atmosphere%20with%20orange%20streetlight%20glow%2C%20moody%20professional%20poster%20art%2C%20high%20detail&width=400&height=600&seq=mock-cover-002&orientation=portrait',
    description:
      '一桩尘封十年的旧案重启，退休警探被迫重返一线。线索如夜色般缠绕，他必须在真相与代价之间做出选择。',
    episodes: 0,
  },
  {
    id: 'v003',
    title: '山那边的信',
    type: 'movie',
    subType: '爱情',
    region: '中国大陆',
    year: 2024,
    genres: ['爱情', '剧情'],
    cast: ['沈南枝', '顾清和', '周晚棠'],
    director: '白景川',
    rating: 7.9,
    views: 7320000,
    likes: 176000,
    updateDate: '2024-08-20',
    status: '已完结',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20romantic%20drama%20movie%20poster%20of%20a%20young%20woman%20holding%20a%20letter%20on%20a%20misty%20mountain%20road%2C%20warm%20golden%20sunset%20light%2C%20soft%20melancholic%20mood%2C%20elegant%20professional%20poster%20art%2C%20high%20detail&width=400&height=600&seq=mock-cover-003&orientation=portrait',
    description:
      '一封迟到了二十年的信，牵出小镇两代人未竟的心愿。关于离别、等待与重逢，写给每一个曾深爱过的人。',
    episodes: 0,
  },
  {
    id: 'v004',
    title: '极速突围',
    type: 'movie',
    subType: '动作',
    region: '美国',
    year: 2023,
    genres: ['动作', '惊悚'],
    cast: ['Marcus Vale', 'Elena Ross', 'Dwight Kane'],
    director: 'Ryan Cole',
    rating: 7.6,
    views: 15680000,
    likes: 402000,
    updateDate: '2024-06-02',
    status: '已完结',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20action%20blockbuster%20movie%20poster%20of%20a%20muscle%20car%20drifting%20through%20a%20city%20highway%20at%20night%2C%20motion%20blur%20and%20orange%20headlights%2C%20gritty%20professional%20poster%20art%2C%20high%20detail&width=400&height=600&seq=mock-cover-004&orientation=portrait',
    description:
      '前特工为洗清冤屈，必须在十二小时内穿越三座城市。每一条隧道都是陷阱，每一次提速都在赌命。',
    episodes: 0,
  },
  {
    id: 'v005',
    title: '长安月下',
    type: 'movie',
    subType: '古装',
    region: '中国大陆',
    year: 2022,
    genres: ['古装', '爱情', '剧情'],
    cast: ['陆清欢', '裴既明', '柳如烟'],
    director: '沈墨白',
    rating: 8.4,
    views: 8890000,
    likes: 264000,
    updateDate: '2024-05-11',
    status: '已完结',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20chinese%20historical%20movie%20poster%20of%20an%20elegant%20ancient%20courtyard%20under%20a%20full%20moon%2C%20silk%20lanterns%20glowing%20warm%20amber%2C%20ink%20painting%20inspired%20professional%20poster%20art%2C%20high%20detail&width=400&height=600&seq=mock-cover-005&orientation=portrait',
    description:
      '盛唐长安，一位才女以一纸画卷卷入朝堂暗涌。月色之下，她与宿敌将军从对立走向相知。',
    episodes: 0,
  },
  {
    id: 'v006',
    title: '深海回声',
    type: 'movie',
    subType: '科幻',
    region: '英国',
    year: 2024,
    genres: ['科幻', '惊悚'],
    cast: ['Arthur Blythe', 'Nina Hart', 'Colin Marsh'],
    director: 'Sofia Grant',
    rating: 8.0,
    views: 6140000,
    likes: 158000,
    updateDate: '2024-09-05',
    status: '已完结',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20deep%20sea%20sci-fi%20movie%20poster%20of%20a%20submersible%20diving%20into%20a%20dark%20abyss%20with%20bioluminescent%20blue%20light%2C%20eerie%20underwater%20atmosphere%2C%20professional%20poster%20art%2C%20high%20detail&width=400&height=600&seq=mock-cover-006&orientation=portrait',
    description:
      '马里亚纳海沟深处传来有规律的信号。科研潜艇下沉七千米，等待他们的是一个不该存在的文明遗迹。',
    episodes: 0,
  },
  {
    id: 'v007',
    title: '风起云岚',
    type: 'tv',
    subType: '古装',
    region: '中国大陆',
    year: 2024,
    genres: ['古装', '权谋', '剧情'],
    cast: ['萧亦寒', '温清月', '裴昭'],
    director: '林砚秋',
    rating: 8.9,
    views: 23400000,
    likes: 762000,
    updateDate: '2024-10-08',
    status: '更新至第38集',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20chinese%20period%20drama%20poster%20of%20a%20general%20in%20flowing%20armor%20before%20a%20misty%20palace%20gate%2C%20cold%20blue%20and%20gold%20tones%2C%20epic%20professional%20poster%20art%2C%20high%20detail&width=400&height=600&seq=mock-cover-007&orientation=portrait',
    description:
      '北境战事初定，朝堂暗流再起。少年将军手握兵符，于权谋棋局中步步为营，只为还天下一个朗朗乾坤。',
    episodes: 42,
  },
  {
    id: 'v008',
    title: '都市夜归人',
    type: 'tv',
    subType: '都市',
    region: '中国大陆',
    year: 2023,
    genres: ['都市', '情感', '生活'],
    cast: ['方知夏', '江屿', '许南风'],
    director: '周牧之',
    rating: 7.8,
    views: 14520000,
    likes: 398000,
    updateDate: '2024-09-22',
    status: '全36集',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20poster%20of%20a%20young%20office%20worker%20walking%20home%20through%20a%20rainy%20city%20street%20at%20night%2C%20warm%20window%20lights%2C%20moody%20professional%20poster%20art%2C%20high%20detail&width=400&height=600&seq=mock-cover-008&orientation=portrait',
    description:
      '凌晨两点的便利店、加班后的末班地铁、出租屋里的一盏灯。三个陌生人的命运在深夜的城市里悄然交汇。',
    episodes: 36,
  },
  {
    id: 'v009',
    title: '谜城档案',
    type: 'tv',
    subType: '悬疑',
    region: '中国大陆',
    year: 2024,
    genres: ['悬疑', '刑侦', '烧脑'],
    cast: ['秦川', '白雅', '邵平川'],
    director: '纪云舟',
    rating: 8.6,
    views: 19870000,
    likes: 588000,
    updateDate: '2024-10-02',
    status: '全24集',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20crime%20mystery%20drama%20poster%20of%20a%20detective%20inspecting%20a%20wall%20covered%20in%20clues%20and%20photos%20in%20a%20dim%20office%2C%20teal%20and%20amber%20lighting%2C%20professional%20poster%20art%2C%20high%20detail&width=400&height=600&seq=mock-cover-009&orientation=portrait',
    description:
      '每一宗案件背后都藏着一座城不为人知的秘密。刑警队长与犯罪心理师联手，解封尘封的谜城档案。',
    episodes: 24,
  },
  {
    id: 'v010',
    title: '少年江湖录',
    type: 'tv',
    subType: '武侠',
    region: '中国大陆',
    year: 2023,
    genres: ['武侠', '成长', '剧情'],
    cast: ['云听澜', '宁无咎', '苏晚照'],
    director: '贺兰山',
    rating: 8.1,
    views: 16730000,
    likes: 476000,
    updateDate: '2024-08-30',
    status: '全40集',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20wuxia%20drama%20poster%20of%20a%20young%20swordsman%20standing%20on%20a%20misty%20bamboo%20cliff%2C%20flowing%20white%20robes%2C%20green%20and%20jade%20tones%2C%20professional%20poster%20art%2C%20high%20detail&width=400&height=600&seq=mock-cover-010&orientation=portrait',
    description:
      '山门被灭的那一夜，少年背着师傅的剑走入江湖。他要用一柄剑，问遍这世上的是非对错。',
    episodes: 40,
  },
  {
    id: 'v011',
    title: '便利店时光',
    type: 'tv',
    subType: '治愈',
    region: '韩国',
    year: 2024,
    genres: ['治愈', '生活', '温情'],
    cast: ['한지원', '서도현', '윤소라'],
    director: '김민재',
    rating: 8.3,
    views: 9260000,
    likes: 288000,
    updateDate: '2024-09-18',
    status: '全16集',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20warm%20healing%20drama%20poster%20of%20a%20cozy%20convenience%20store%20at%20dusk%20with%20glowing%20lights%2C%20soft%20pastel%20pastel%20tones%2C%20gentle%20professional%20poster%20art%2C%20high%20detail&width=400&height=600&seq=mock-cover-011&orientation=portrait',
    description:
      '开在巷子口的 24 小时便利店，收留着深夜里无处安放的心事。一碗泡面、一句问候，治愈每一个疲惫的夜晚。',
    episodes: 16,
  },
  {
    id: 'v012',
    title: '深空前哨',
    type: 'tv',
    subType: '科幻',
    region: '美国',
    year: 2023,
    genres: ['科幻', '悬疑'],
    cast: ['Ava Sinclair', 'Leon Park', 'Mira Okoye'],
    director: 'Daniel Wexler',
    rating: 8.5,
    views: 11340000,
    likes: 342000,
    updateDate: '2024-07-28',
    status: '全10集',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20space%20sci-fi%20series%20poster%20of%20a%20remote%20orbital%20outpost%20silhouetted%20against%20a%20vast%20nebula%2C%20cold%20blue%20and%20purple%20glow%2C%20professional%20poster%20art%2C%20high%20detail&width=400&height=600&seq=mock-cover-012&orientation=portrait',
    description:
      '距地球最远的哨站突然与地面失联。留守的六名船员发现，真正的威胁并非来自舱外，而是彼此。',
    episodes: 10,
  },
  {
    id: 'v013',
    title: '欢乐总动员',
    type: 'variety',
    subType: '真人秀',
    region: '中国大陆',
    year: 2024,
    genres: ['真人秀', '搞笑', '竞技'],
    cast: ['何嘉乐', '杜子腾', '宋小满'],
    director: '快乐星球制作组',
    rating: 8.0,
    views: 28600000,
    likes: 842000,
    updateDate: '2024-10-10',
    status: '更新至第9期',
    cover:
      'https://readdy.ai/api/search-image?query=colorful%20variety%20show%20poster%20of%20a%20joyful%20tv%20studio%20stage%20with%20confetti%20and%20warm%20stage%20lights%2C%20vibrant%20orange%20and%20teal%20tones%2C%20playful%20professional%20poster%20art%2C%20high%20detail&width=400&height=600&seq=mock-cover-013&orientation=portrait',
    description:
      '全新一季欢乐总动员火爆来袭！明星嘉宾组队闯关，爆笑游戏与高能反转轮番上演，每一期都笑到停不下来。',
    episodes: 9,
  },
  {
    id: 'v014',
    title: '音乐新声代',
    type: 'variety',
    subType: '音乐',
    region: '中国大陆',
    year: 2024,
    genres: ['音乐', '竞演'],
    cast: ['歌手集结'],
    director: '星音乐制作组',
    rating: 8.2,
    views: 21400000,
    likes: 692000,
    updateDate: '2024-10-09',
    status: '更新至第6期',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20music%20competition%20show%20poster%20of%20a%20singer%20on%20a%20dark%20stage%20bathed%20in%20warm%20spotlight%20and%20golden%20bokeh%2C%20elegant%20professional%20poster%20art%2C%20high%20detail&width=400&height=600&seq=mock-cover-014&orientation=portrait',
    description:
      '来自各地的新生代歌手同台竞技，原创与改编轮番炸场。谁能用一首歌，唱进所有人的心里？',
    episodes: 6,
  },
  {
    id: 'v015',
    title: '舌尖漫游记',
    type: 'variety',
    subType: '美食',
    region: '中国大陆',
    year: 2023,
    genres: ['美食', '纪录'],
    cast: ['味道小分队'],
    director: '寻味制作组',
    rating: 8.8,
    views: 17980000,
    likes: 624000,
    updateDate: '2024-06-20',
    status: '全12期',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20food%20documentary%20poster%20of%20steaming%20regional%20chinese%20dishes%20on%20a%20rustic%20wooden%20table%2C%20warm%20appetizing%20lighting%2C%20professional%20poster%20art%2C%20high%20detail&width=400&height=600&seq=mock-cover-015&orientation=portrait',
    description:
      '从街边小摊到深山灶台，一路寻味。每座城都有属于自己的味道，这一次，我们把它端上你的餐桌。',
    episodes: 12,
  },
  {
    id: 'v016',
    title: '逃出密室吧',
    type: 'variety',
    subType: '真人秀',
    region: '中国大陆',
    year: 2024,
    genres: ['真人秀', '推理'],
    cast: ['推理小队'],
    director: '解谜制作组',
    rating: 7.7,
    views: 13920000,
    likes: 386000,
    updateDate: '2024-10-06',
    status: '更新至第5期',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20escape%20room%20reality%20show%20poster%20of%20a%20mysterious%20dim%20room%20with%20clues%20and%20a%20single%20glowing%20door%2C%20teal%20and%20amber%20tones%2C%20professional%20poster%20art%2C%20high%20detail&width=400&height=600&seq=mock-cover-016&orientation=portrait',
    description:
      '六位嘉宾被困精心设计的巨型密室，线索环环相扣，逃跑倒计时已经开始。他们能否全身而退？',
    episodes: 5,
  },
  {
    id: 'v017',
    title: '喜剧之王夜',
    type: 'variety',
    subType: '脱口秀',
    region: '中国大陆',
    year: 2023,
    genres: ['脱口秀', '搞笑'],
    cast: ['笑果特辑'],
    director: '爆梗制作组',
    rating: 8.4,
    views: 22860000,
    likes: 728000,
    updateDate: '2024-09-12',
    status: '全10期',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20stand-up%20comedy%20special%20poster%20of%20a%20microphone%20on%20an%20empty%20stage%20with%20a%20single%20warm%20spotlight%20and%20red%20curtain%2C%20professional%20poster%20art%2C%20high%20detail&width=400&height=600&seq=mock-cover-017&orientation=portrait',
    description:
      '生活很苦，喜剧很甜。一线脱口秀演员轮番登台，把日常的烦恼熬成一整晚的爆梗与笑声。',
    episodes: 10,
  },
  {
    id: 'v018',
    title: '荒野求生记',
    type: 'variety',
    subType: '户外',
    region: '英国',
    year: 2024,
    genres: ['户外', '挑战', '纪录'],
    cast: ['Eddie Stone', 'Kate Alpine'],
    director: 'Wild Studio',
    rating: 8.1,
    views: 8760000,
    likes: 254000,
    updateDate: '2024-08-14',
    status: '更新至第7期',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20wilderness%20survival%20show%20poster%20of%20a%20lone%20hiker%20against%20misty%20jagged%20mountains%20at%20dawn%2C%20cold%20blue%20and%20green%20tones%2C%20professional%20poster%20art%2C%20high%20detail&width=400&height=600&seq=mock-cover-018&orientation=portrait',
    description:
      '没有补给、没有剧本，只有一双手和一片荒野。两位求生专家深入无人之境，挑战人类极限。',
    episodes: 7,
  },
];